import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Storniert',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Erhalten',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Bestätigt',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'Wird vorbereitet',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'Unterwegs',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Bereit',
  served: 'Serviert',
  status: {
    actual: 'Aktuell',
    pending: 'Ausstehend',
  },
  warning_label: {
    pickup_time_changed: '{{company}} änderte die Zeit von {{initialTime}} auf {{currentTime}}',
  },
  labels: {
    order_number: 'Bestell Nr: {{number}}',
    today: 'Heute',
  },
};
